import { PartnerApi } from "../../api/partner.api";
import React, { useState, useEffect } from "react";
import ReactPDF from "react-pdf-js";

const fetchBlobPDF = async (invoice_id, token) => {
  const response = await PartnerApi.download(
    "/invoice/" + invoice_id + "/download.pdf",
    false,
    token
  );
  return response;
};

const InvoiceCanvas = ({ invoice_id, token }) => {
  const [blobURL, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchBlobPDF(invoice_id, token);
        setData(result); // Uložení výsledku do stavu
      } catch (err) {
        setError(err); // Nastavení chyby, pokud něco selže
      } finally {
        setLoading(false); // Nastavení, že načítání je hotové
      }
    };

    getData(); // Zavolání asynchronní funkce
  }, [invoice_id]);

  if (loading) return "Nahrávám PDF";
  if (error)
    return (
      <p>
        <strong>Chyba downloadu:</strong> {error.message}
      </p>
    );
  return (
    <>
      <iframe src={blobURL} style={{ width: "100%", height: "70vh" }} />
    </>
  );
};

export default InvoiceCanvas;
